import React, { Component } from 'react';

import 'bootstrap/dist/css/bootstrap.min.css'; 
import './Main.css'
import Menu from '../Components/Menu/Menu' 

class Layout extends Component {
    render() {
        return (
            <> 
                <Menu/>
            </>
        );
    }
}

export default Layout;
